import React, { useEffect } from 'react';
import { Game } from '../types/types';
import styled from '@emotion/styled';
import { get_suffix } from '../globals/Globals';
import { Chip, useTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';
export interface Props {
    game: Game;
}



const PosRank = ({game}:Props) => {
    const theme = useTheme()
    const router = useNavigate();

    const PositionChip = styled(Chip)`
        background-color: ${theme.palette.mode === 'dark' ? '#121212' : "white"};
        margin-top: 0.5rem;
        cursor: pointer;
        .MuiChip-deleteIcon {
            padding-right: 0.5rem;
            color: ${theme.palette.mode === 'dark' ? 'white' : "#121212"};
            font-size: 1rem !important;
            @media (min-width: 800px) {
                line-height: 21.6px !important;
            }
            
        }
        &:hover {
            background-color: ${theme.palette.mode === 'dark' ? 'white' : "#121212"};
            color: ${theme.palette.mode === 'dark' ? 'white' : '#121212'}
            &.MuiChip-deleteIcon { 
                color: ${theme.palette.mode === 'dark' ? 'white' : '#121212'} ;
            }
        }
    `
    if (!game) {
        return null
    }
    return <div style={{display: "flex", justifyContent: "center"}}>
        {game?.positionrank.map(function(rank) {
            return <PositionChip label={rank.position.name} deleteIcon={<p>{get_suffix(rank.totalrank)}</p>} onClick={e => router(`/position/${rank.position.name}`)} onDelete={e => router(`/position/${rank.position.name}`)}/>
        })}
    </div>
}

export default PosRank;